export const SELECTORS = {
    PP_CHOOSER: '.js-pp-chooser',
    PP_SEARCH_FIELD: '.js-pp-search',
    PP_SEARCH_ITEM: '.js-pp-search-item',
    PP_SEARCH_RESET: '.js-pp-search__reset'
};

export const CLASSES = {
    PP_SEARCH_ITEM_HIDDEN: 'pp-search-item--hidden'
};

export const ATTRIBUTES = {
    PP_TYPES: 'data-pp-types',
    PP_NAME: 'data-pp-name'
};
